import {Component, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import { MatDialog } from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {TaskManagerState} from '../../store/task-manager.reducer';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {
  CreateKanbanBoardCommand, DeleteBoardCommand, MarkAsFavoriteBoardCommand,
  RenameBoardCommand
} from '../../commands/task-manager.command';
import {DialogModel} from '@shared/models/dialog.model';
import {Location} from '@angular/common';
import {TaskManagerService} from '../../services/task-manager.service';
import {MemberDialogModel, ShareItemService} from '@shared/services/share-item.service';
import {TaskManagerApiService} from '../../services/task-manager-api.service';
import {AddMemberToItemCommand} from '../../../../commands/contacts.command';
import {Subject} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {UserInfo} from '@shared/models/user-info.model';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {BoardOwner, NoAccess} from '../../constants/task-manager.constants';
import { PlatformCommand } from '@shared/commands/command-base';

@Component({
    standalone: false,
    selector: 'particle-task-manager-board-tile',
  templateUrl: './task-manager-board-tile.component.html',
  styleUrls: ['./task-manager-board-tile.component.scss']
})
export class TaskManagerBoardTileComponent implements OnInit, OnDestroy {
  dialogRef: any;
  selectedItems: any[];
  companyBoards: any;
  supportBoards: any;
  breadcrumbs: BreadcrumbModel[];
  tileGroups$: any;
  tileGroups: any;
  unsubscribe$ = new Subject<void>();
  defaultBoardPermission = {
    'title': 'No Access',
    'description': 'Cannot access any ticket(s)',
    'permissionType': 0
  };
  protected userInfo: UserInfo;

  constructor(protected dialog: MatDialog,
              protected router: Router,
              protected activatedRoute: ActivatedRoute,
              protected location: Location,
              protected taskManagerStore: Store<TaskManagerState>,
              protected securityStore: Store<SecurityState>,
              protected dialogService: DialogService,
              protected commandService: CommandService,
              protected queryStore: Store<IQueryState>,
              protected taskManagerService: TaskManagerService,
              protected taskManagerApiService: TaskManagerApiService,
              protected shareItemService: ShareItemService,
  ) {
    this.selectedItems = [];
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'TaskManager',
        title: 'Task Manager',
        relativeUrl: 'task-manager/' + this.getViewType(),
        type: 'Repository'
      }
    ];
  }

  getViewType() {
    // return 'card'; // changing to grid view for performance reason
    return 'grid';
  }

  getViewTypeforsupportboard() {
    return 'grid';
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit() {
    this.tileGroups$ = this.queryStore.pipe(select(getQueryResponse, 'task-manager-tiles'));
    this.tileGroups$.subscribe(data => {
      if (data) {
        console.log(data);
        this.tileGroups = data.tileGroups;
      }
    });
    QueryProvider.invokeQuery(this.queryStore, 'task-manager-tiles', {});
    this.securityStore.pipe(select(getUserInfo)).subscribe(state => this.userInfo = state);
  }

  stopPropagating($event) {
    $event.stopPropagation();
    $event.preventDefault();
  }

  markAsFavorite($event, tile: any) {
    $event.stopPropagation();
    $event.preventDefault();
    console.log('Mark as Favorite', tile);
    const command = new MarkAsFavoriteBoardCommand(tile.id, !tile.isFavorite, tile.type === 'OrbitaxSupport' ? 3 : 1);
    this.commandService.executeCommand(command).subscribe(response => {
      console.log(response);
      QueryProvider.invokeQuery(this.queryStore, 'task-manager-tiles', {});
    });
  }

  navigateToBoardTile(tile: any) {
    const command = new PlatformCommand('ViewBoardActivityCommand', 'TaskManagerApi');
    command.fieldValues["boardId"]=tile?.id;

    switch (tile.type) {
      case 'OrbitaxSupport':
        this.navigateToSupportBoard();
        break;
      case 'Team':
        this.navigateToTeamBoard(tile.id);
        break;
      case 'Personal':
        this.navigateToPersonalBoard(tile.id);
        break;
    }

    this.commandService.executePlatformCommand(command).pipe().subscribe(response=>console.log(response));
  }

  isPersonal(tile: any) {
    if (tile.type === 'Personal') {
      return true;
    }
    return false;
  }

  isTeam(tile: any) {
    if (tile.type === 'Team' && tile.isDefault === true) {
      return true;
    }
    return false;
  }

  isCustom(tile: any) {
    if (tile.type === 'Team' && tile.isDefault === false) {
      return true;
    }
    return false;
  }

  hasPermission(tile: any) {
    if (tile.hasPermission && tile.isDefault === false) {
      return true;
    }
    return false;
  }

  navigateToTeamBoard(id: string) {
    const url = `task-manager/team/${this.getViewType()}/${id}`;
    this.router.navigateByUrl(url);
  }

  navigateToPersonalBoard(id: string) {
    const url = `task-manager/personal/${this.getViewType()}/${id}`;
    this.router.navigateByUrl(url);
  }

  navigateToSupportBoard() {
    const url = `task-manager/support/${this.getViewTypeforsupportboard()}`;
    this.router.navigateByUrl(url);
  }

  addBoard(tileGroup: any) {
    const dialogModel = DialogModel.create('Add Board', 'AddBoardDialogComponent', {title: ''});
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(state => {
      if (state && state.action === 'OK') {
        const command = new CreateKanbanBoardCommand(state.data.input.boardName, tileGroup.type);
        this.commandService.executeCommand(command).subscribe(response => {
          console.log(response);
          if (response.Payload.Type === 'Team') {
            this.navigateToTeamBoard(response.Payload.Id);
          } else {
            this.navigateToPersonalBoard(response.Payload.Id);
          }
        });
      }
      console.log(state);
    });
  }

  openBoard(tile: any) {
    switch (tile.type) {
      case 'OrbitaxSupport':
      case 'Support':
        this.navigateToSupportBoard();
        break;
      case 'Team':
        this.navigateToTeamBoard(tile.id);
        break;
      case 'Personal':
        this.navigateToPersonalBoard(tile.id);
        break;
    }
  }

  renameBoard(tile) {
    const dialogModel = DialogModel.create('Rename Board', 'AddBoardDialogComponent', {title: tile.displayText});
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(state => {
      if (state && state.action === 'OK') {
        if (state.data.input.boardName !== '' && state.data.input.boardName !== tile.displayText) {
          const command = new RenameBoardCommand(state.data.input.boardName, tile.id);
          this.commandService.executeCommand(command).pipe().subscribe(data => {
            this.taskManagerService.handleBoardsUpdate();
          });
        }
      }
      console.log(state);
    });
  }

  openManageMembersDialog(tile) {
    const model = new MemberDialogModel();
    model.configKey = 'BoardMembersKey';
    model.itemId = tile.id;
    model.metaData = {
      'BoardName': tile.title
    };
    this.taskManagerApiService.getBoardMembersByBoard(tile.id).pipe( take(2) ).subscribe(board => {
      if (board) {
        const selectedUsers = this.shareItemService.mapSelectedUserWithPermission(board.userGroups, BoardOwner);
        const maxPermission = this.getMaxPermissionForBoard(selectedUsers, tile);
        const contactsMetaData = {
          'selectedUsers': selectedUsers,
          'permissions': board.permissions.filter(p => p.permissionType <= maxPermission),
          'defaultPermission': this.defaultBoardPermission,
          'maxPermission': maxPermission
        };
        const command = new AddMemberToItemCommand('', tile.id, [], model.metaData);
        this.shareItemService.showDialog(model, contactsMetaData, command);
      }
    });
  }

  deleteBoard(tile: any) {
    this.taskManagerApiService.getTicketCount(tile.id, 1).pipe(takeUntil(this.unsubscribe$)).subscribe(x => {
      const confirmTxt = x === 0 ? 'Are you sure you want to delete?' : `This board has ${x} task(s).  Deleting it will also delete the task(s). Are you sure you want to delete this board and it's task(s)?`;
      this.dialogService.showYesNoDialog('Confirm Delete', confirmTxt).pipe().subscribe(state => {
        if (state && state.action === 'OK') {
          const command = new DeleteBoardCommand(tile.id);
          this.commandService.executeCommand(command).pipe().subscribe(data => {
            this.taskManagerService.handleBoardsUpdate();
          });
        }
      });
    });
  }

  protected getMaxPermissionForBoard(selectedUsers: any, item: any): number {
    const permissionType = selectedUsers[this.userInfo.email].permission.permissionType;
    if (item.hasPermission) {
      return permissionType;
    }
    if (permissionType === NoAccess) {
      return this.userInfo.email === item.cells.CreatedBy.value.email ? BoardOwner : permissionType;
    } else {
      return permissionType;
    }
  }

}
